import { memo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { OutletIProps } from '../../../components/sitebase/Base.types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from '@mui/material';
import PointInformation from '../cart/components/PointInformation';
import PointProbability from '../cart/components/PointProbability';
import type { AlertPoint, CartNotificationPoint } from '../notifications/Notification.types';

export default memo(function CartNotificationEntry(props: {
    point: CartNotificationPoint,
    alert_point: AlertPoint
    notification_type: number,
    notification_id: string,
    multiple_points: boolean,
    fetchNotificationsData: () => void,
}) {
    const context = useOutletContext<OutletIProps>();
    const isFlash = props.notification_type === 3;

    return (
        <tbody>
            <tr className={`col ${props.alert_point.disabled_by ? "table-secondary" : ""}`}>
                <td className='col-3'>
                    <PointInformation point={props.point} isFlash={isFlash} showFormalNotMetCriteria={false} />
                </td>
                <td className='col-2'>
                    <div className='btn btn-success fs-9'>{props.point.MOU_Status}</div>
                </td>
                <td className='col-4'>
                    <PointProbability point={props.point} isFlash={isFlash} />
                </td>
                <td className='col-1'>
                    <Tooltip title="View notification details" placement="bottom" arrow disableInteractive>
                        <a className='mx-auto my-auto' href={`/notifications-archive/detail/${props.notification_id}`} target='_blank' rel='noreferrer'>
                            <div role='button' className={`btn btn-outline py-1 ${props.alert_point.disabled_by ? "border-dark" : "border"}`}>
                                <FontAwesomeIcon icon={faInfoCircle} />
                            </div>
                        </a>
                    </Tooltip>
                    {props.multiple_points && !props.alert_point.disabled_by ?
                        <div role='button' className='btn btn-outline-warning text-dark py-0 m-1 border'
                            onClick={() => {
                                if (confirm(`Do you want to close this point?`))
                                    fetch(`/api/notifications/alert-points/${props.alert_point.id}/?format=json`,
                                        {
                                            method: "PATCH",
                                            credentials: "include",
                                            headers: {
                                                "Content-Type": "application/json",
                                                "Accept": "application/json",
                                            },
                                            body: JSON.stringify({
                                                disabled_by: context.user.email,
                                            })
                                        }
                                    ).then((response) => {
                                        if (response.ok) {
                                            return response.json().then(() => {
                                                toast.success("Alert point deactivated");
                                                props.fetchNotificationsData();
                                            });
                                        } else {
                                            return response.json().then((data) => {
                                                toast.error(data.detail);
                                            });
                                        }
                                    });
                            }}>
                            <FontAwesomeIcon icon={faCheckSquare} />
                        </div> : null}
                </td>

            </tr>
        </tbody>
    );
})